export default __webpack_public_path__ + "static/media/dis3.a5ea052b.webp";